export default "__VITE_ASSET__CbNabg7l__"